/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Window_Resize_BottomInputs */

const en_window_resize_bottom = /** @type {(inputs: Window_Resize_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resize from bottom edge`)
};

const ar_window_resize_bottom = /** @type {(inputs: Window_Resize_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تغيير الحجم من الحافة السفلية`)
};

const bn_window_resize_bottom = /** @type {(inputs: Window_Resize_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নিচের কিনারা থেকে রিসাইজ করুন`)
};

const de_window_resize_bottom = /** @type {(inputs: Window_Resize_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Größe vom unteren Rand ändern`)
};

const es_window_resize_bottom = /** @type {(inputs: Window_Resize_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar tamaño desde el borde inferior`)
};

const fr_window_resize_bottom = /** @type {(inputs: Window_Resize_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redimensionner à partir du bord inférieur`)
};

const pt_window_resize_bottom = /** @type {(inputs: Window_Resize_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redimensionar a partir da borda inferior`)
};

const zh_window_resize_bottom = /** @type {(inputs: Window_Resize_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从底部边缘调整大小`)
};

const tr_window_resize_bottom = /** @type {(inputs: Window_Resize_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alt kenardan yeniden boyutlandır`)
};

const ru_window_resize_bottom = /** @type {(inputs: Window_Resize_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменение размера от нижнего края`)
};

const pl_window_resize_bottom = /** @type {(inputs: Window_Resize_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmień rozmiar od dolnej krawędzi`)
};

/**
* | output |
* | --- |
* | "Resize from bottom edge" |
*
* @param {Window_Resize_BottomInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const window_resize_bottom = /** @type {((inputs?: Window_Resize_BottomInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Window_Resize_BottomInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_window_resize_bottom(inputs)
	if (locale === "bn") return bn_window_resize_bottom(inputs)
	if (locale === "de") return de_window_resize_bottom(inputs)
	if (locale === "es") return es_window_resize_bottom(inputs)
	if (locale === "fr") return fr_window_resize_bottom(inputs)
	if (locale === "pt") return pt_window_resize_bottom(inputs)
	if (locale === "zh") return zh_window_resize_bottom(inputs)
	if (locale === "tr") return tr_window_resize_bottom(inputs)
	if (locale === "ru") return ru_window_resize_bottom(inputs)
	if (locale === "pl") return pl_window_resize_bottom(inputs)
	return en_window_resize_bottom(inputs)
});